export default "__VITE_ASSET__Da75XRdH__"